import React from "react";
import { Label } from "@src/components";
import { INVALID_VALUE } from "@src/constants/InvalidValue";
import { ConvertPrice } from "@src/utils/units";

const cellStyle: React.CSSProperties = {
    width: "100%",
    minWidth: "80px",
    textAlign: "center",
};

export const getColumns = () => [
    {
        Header: "결제번호",
        accessor: "orderNo",
        Cell: ({ cell: { value } }: any) => (
            <div style={cellStyle}>{value ?? INVALID_VALUE}</div>
        ),
    },
    {
        Header: "이름",
        accessor: "name",
        Cell: ({ cell: { value } }: any) => (
            <div style={cellStyle}>{value ? value : INVALID_VALUE}</div>
        ),
    },
    {
        Header: "이메일",
        accessor: "email",
        Cell: ({ cell: { value } }: any) => (
            <div
                style={{
                    ...cellStyle,
                    minWidth: "160px",
                    textDecoration: "underline",
                }}
            >
                {value ? value : INVALID_VALUE}
            </div>
        ),
    },
    {
        Header: "전화번호",
        accessor: "phone",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ ...cellStyle, minWidth: "110px" }}>
                {value ? value : INVALID_VALUE}
            </div>
        ),
    },
    {
        Header: "결제금액",
        accessor: "paidPrice",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ ...cellStyle, minWidth: "100px" }}>
                {value || value === 0 ? ConvertPrice(value) : INVALID_VALUE}
            </div>
        ),
    },
    {
        Header: "구독권",
        accessor: "subscriptionName",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ ...cellStyle, minWidth: "100px" }}>
                {value ? <Label text={value} color="purple" /> : INVALID_VALUE}
            </div>
        ),
    },
    {
        Header: "클래스",
        accessor: "className",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ ...cellStyle, minWidth: "120px" }}>
                {value ? value : INVALID_VALUE}
            </div>
        ),
    },
];
